import { Card, CardMedia, CardContent, Typography } from "@mui/material";
import StatusCard from 'src/components/landing/StatusCard';
import Teamwork from 'src/assets/img/teamwork.jpeg';


export default function WorkingSection() {
    return (
        <section className="pb-20 bg-gray-100 -mt-32">
            <div className="container max-w-7xl mx-auto px-4">
                <div className="flex flex-wrap relative z-50">

                    <StatusCard color="red" path="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" title="Right Pricing">
                    No hidden charges, no suspicious plans, no conspiracy theories, Just pay per Usage.
                    </StatusCard>
                    <StatusCard
                        color="lightBlue"
                        path="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z"
                        title="Easy to use"
                    >                        
                    LabAsService has an easy-to-use UI and dashboard to Manage the lab servers.
                    </StatusCard>
                    <StatusCard
                        color="teal"
                        path="M3 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
                        title="Schedule"
                    >
                        Can schedule the powering on/off of lab servers on specific day and time.
                    </StatusCard>
                </div>

                <div className="flex flex-wrap items-center mt-32">
                    <div className="w-full md:w-5/12 px-4 mx-auto">
                        <div className="text-blue-gray-800 p-3 text-center inline-flex items-center justify-center w-16 h-16 mb-6 shadow-lg rounded-full bg-white">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                          <path d="M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z" />
                        </svg>
                        </div>
                        {/* <H4 color="gray">LabAsService</H4> */}
                        <Typography variant="h4" color="gray" className="mb-4">
                            LabAsService
                        </Typography>
                        <Typography variant="body1" color="text.secondary" className="mb-2">
                        Labs are a very important ingredient for successful training. Hands-on experience is required to translate knowledge into real-world results.
                        </Typography>
                        <Typography variant="body1" color="text.secondary">
                        Well Performing ready to use labs is very important to keep the participants engaged. Trainers and training organizations spend lots of effort in setting up the labs or the training hours are wasted in troubleshooting lab environments.
                        </Typography>
                            <a
                                href="https://www.zippyops.com/labasservice"
                                target="_blank"
                                rel="noreferrer"
                                ripple="light"
                                className="font-medium text-light-blue-500 mt-2 inline-block"
                            >
                                Read More 
                            </a>
                    </div>

                    <div className="w-full md:w-5/12 px-4 mx-auto flex justify-center mt-24 lg:mt-0">
                        <Card sx={{ maxWidth: 345 }}>
                            <CardMedia
                                component="img"
                                alt="Card Image"
                                height="200"
                                image={Teamwork}
                            />
                            <CardContent>
                                <Typography variant="h6" color="text.primary" className="mb-4">
                                        Customized lab avaliable on request
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                The shoe that fits one person pinches another; there is no recipe for living that suits all cases. We also offer customized lab that meets your need.
                                </Typography>
                            </CardContent>
                        </Card>
                    </div>
                </div>
            </div>
        </section>
    );
}
